import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, deleteUser } from '../../redux/actions/user/userAction';
import DataTable from 'react-data-table-component';
import { Box, IconButton, TextField, Typography, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { confirmDelete, showSuccess } from '../../utils/alertUtils'; 
import { toast } from 'react-toastify';

const UserTable = ({ onEdit }) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user.users);
  const { user } = useSelector((state) => state.login);
  const [filterText, setFilterText] = useState('');

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleDelete = async (id) => {
      const result = await confirmDelete('Are you sure?', 'This will delete the user permanently!');
      if (result.isConfirmed) {
        try {
          await dispatch(deleteUser(id));
          showSuccess('Deleted!', 'The user has been deleted.');
        } catch (error) {
          const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete user';
          toast.error(errorMessage);
        }
      }
    };

  const handleNew = () => {
    onEdit(null); // This will reset the form and show it in "Add" mode
  };

  const filteredUsers = users.filter((user) =>
    (user.username || '').toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: <Typography fontWeight="bold">Username</Typography>,
      selector: (row) => row.username,
      sortable: true,
    },
     {
      name: <Typography fontWeight="bold">Password</Typography>,
      selector: (row) => row.password,
      sortable: true,
    },
     {
      name: <Typography fontWeight="bold">Role</Typography>,
      selector: (row) => row.role,
      sortable: true,
    },
   {
      name: <Typography fontWeight="bold">Status</Typography>,
      selector: (row) => row.status,
      sortable: true,
    },
     
    ...(user?.role === 'Admin' ? [{
      name: <Typography fontWeight="bold">Actions</Typography>,
      cell: (row) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton size="small" onClick={() => onEdit(row)}>
            <EditIcon fontSize="small" sx={{ color: '#2196f3' }}/>
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.id)}>
            <DeleteIcon fontSize="small" sx={{ color: '#f44336' }}/>
          </IconButton>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }] : []),
  ];

  return (
   
  <Box>
    {/* Header Row with Title & Search */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Users
        </Typography>
        {user?.role === 'Admin' && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleNew}
            size="small"
            sx={{ 
              backgroundColor: '#2196f3',
              '&:hover': {
                backgroundColor: '#1976d2',
              },
            }}
          >
            New
          </Button>
        )}
      </Box>

      <TextField
        size="small"
        placeholder="Search role..."
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
        sx={{
          width: '250px',
          '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
          },
        }}
      />
    </Box>

    {/* Table */}
    <Box sx={{ height: '400px', overflowY: 'auto' }}>
    <DataTable
      columns={columns}
      data={filteredUsers}
      pagination
      highlightOnHover
      dense
      responsive
      noHeader
    />
  </Box>
  </Box>
);
};

export default UserTable;
